import { render, staticRenderFns } from "./goodStatistics-add-or-update.vue?vue&type=template&id=263e5cfa&"
import script from "./goodStatistics-add-or-update.vue?vue&type=script&lang=js&"
export * from "./goodStatistics-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports